import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-four-lesson-six-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFourLessonSixGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 4, Lesson 6 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 6: Writing a Thank You Note";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
